if (typeof window.__divanoVariantSlideoverDefined === 'undefined') {
window.__divanoVariantSlideoverDefined = true;

class DivanoVariantSlideover extends HTMLElement {
  static get observedAttributes() {
    return ['data-selected'];
  }

  connectedCallback() {
    this._option = this.dataset.option || '';
    this._paramKey = this.dataset.paramKey || this._option.toLowerCase();
    this._showFilters = this.dataset.showFilters === 'true';
    this._showTabs = this.dataset.showTabs === 'true';

    this._summaryButton = this.querySelector('[data-role="summary"]');
    this._viewAllButton = this.querySelector('[data-role="view-all"]');
    this._selectionLabel = this.querySelector('[data-role="selection-label"]');
    this._dialog = this.querySelector('dialog[data-role="slideover-dialog"]');
    this._closeButton = this.querySelector('[data-role="close"]');
    this._tiles = Array.from(this.querySelectorAll('[data-role="tile"]'));
    this._inputs = Array.from(this.querySelectorAll('input[type="radio"]'));
    this._filterChips = Array.from(
      this.querySelectorAll('[data-role="filter-chip"]')
    );
    this._tabButtons = Array.from(this.querySelectorAll('[data-role="tab"]'));
    this._emptyState = this.querySelector('[data-role="empty-state"]');

    this._activeFilters = new Set();
    this._activeTab = this.dataset.defaultTab || 'in_stock';
    this._priorSelection = null;

    this._onChange = this._onChange.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onDialogCancel = this._onDialogCancel.bind(this);

    this.addEventListener('change', this._onChange);
    this.addEventListener('click', this._onClick);
    if (this._dialog) this._dialog.addEventListener('cancel', this._onDialogCancel);

    const url = new URL(window.location.href);
    const fromUrl = url.searchParams.get(this._paramKey);
    if (fromUrl) {
      const match = this._inputs.find((i) => i.value === fromUrl);
      if (match && !match.checked) {
        match.checked = true;
        this._syncSelectionLabel(match.value);
      }
    } else {
      const checked = this._inputs.find((i) => i.checked);
      if (checked) this._syncSelectionLabel(checked.value);
    }

    if (this._showTabs) this._applyTab();
    this._applyFilters();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this._onChange);
    this.removeEventListener('click', this._onClick);
    if (this._dialog) this._dialog.removeEventListener('cancel', this._onDialogCancel);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (!this._inputs) return;
    if (name === 'data-selected' && newValue && newValue !== oldValue) {
      const match = this._inputs.find((i) => i.value === newValue);
      if (match) match.checked = true;
      this._syncSelectionLabel(newValue);
    }
  }

  _onChange(event) {
    if (event.target.matches('input[type="radio"]')) {
      const value = event.target.value;
      this._syncSelectionLabel(value);
      this.dispatchEvent(
        new CustomEvent('divano:variant:select', {
          bubbles: true,
          detail: {
            option: this._option,
            paramKey: this._paramKey,
            value,
          },
        })
      );
    }
  }

  _onClick(event) {
    const opener = event.target.closest(
      '[data-role="summary"], [data-role="view-all"]'
    );
    if (opener && this._dialog && typeof this._dialog.showModal === 'function') {
      const checked = this._inputs.find((i) => i.checked);
      this._priorSelection = checked ? checked.value : null;
      this._dialog.showModal();
      return;
    }

    if (event.target.closest('[data-role="close"]')) {
      if (this._dialog && this._dialog.open) this._dialog.close();
      return;
    }

    const filterChip = event.target.closest('[data-role="filter-chip"]');
    if (filterChip) {
      const tag = filterChip.dataset.filterTag;
      if (tag === 'all') {
        this._activeFilters.clear();
        this._filterChips.forEach((c) => {
          c.setAttribute(
            'aria-pressed',
            c.dataset.filterTag === 'all' ? 'true' : 'false'
          );
        });
      } else {
        if (this._activeFilters.has(tag)) {
          this._activeFilters.delete(tag);
          filterChip.setAttribute('aria-pressed', 'false');
        } else {
          this._activeFilters.add(tag);
          filterChip.setAttribute('aria-pressed', 'true');
        }
        const allChip = this._filterChips.find(
          (c) => c.dataset.filterTag === 'all'
        );
        if (allChip)
          allChip.setAttribute(
            'aria-pressed',
            this._activeFilters.size === 0 ? 'true' : 'false'
          );
      }
      this._applyFilters();
      return;
    }

    const tab = event.target.closest('[data-role="tab"]');
    if (tab) {
      this._activeTab = tab.dataset.tabValue;
      this._tabButtons.forEach((t) => {
        t.setAttribute(
          'aria-selected',
          t.dataset.tabValue === this._activeTab ? 'true' : 'false'
        );
      });
      this._applyTab();
      this._applyFilters();
      return;
    }
  }

  _onDialogCancel() {
    if (this._priorSelection) {
      const match = this._inputs.find((i) => i.value === this._priorSelection);
      if (match) {
        match.checked = true;
        this._syncSelectionLabel(this._priorSelection);
      }
    }
  }

  _applyTab() {
    if (!this._showTabs) return;
    const wantMto = this._activeTab === 'made_to_order';
    this._tiles.forEach((tile) => {
      const isMto = tile.dataset.mto === 'true';
      tile.dataset.hiddenByTab = isMto === wantMto ? 'false' : 'true';
      this._syncTileVisibility(tile);
    });
  }

  _applyFilters() {
    if (this._showFilters) {
      this._tiles.forEach((tile) => {
        if (this._activeFilters.size === 0) {
          tile.dataset.hiddenByFilter = 'false';
        } else {
          const tags = (tile.dataset.attributeTags || '')
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
          const matches = Array.from(this._activeFilters).some((f) =>
            tags.includes(f)
          );
          tile.dataset.hiddenByFilter = matches ? 'false' : 'true';
        }
        this._syncTileVisibility(tile);
      });
    }

    if (this._emptyState) {
      const visibleCount = this._tiles.filter(
        (t) =>
          t.dataset.hiddenByFilter !== 'true' &&
          t.dataset.hiddenByTab !== 'true'
      ).length;
      this._emptyState.hidden = visibleCount > 0;
    }
  }

  _syncTileVisibility(tile) {
    const hidden =
      tile.dataset.hiddenByFilter === 'true' ||
      tile.dataset.hiddenByTab === 'true';
    tile.hidden = hidden;
  }

  _syncSelectionLabel(value) {
    if (!this._selectionLabel) return;
    const matchingTile = this._tiles.find((t) => t.dataset.tile === value);
    const display = matchingTile?.dataset.displayLabel || value;
    this._selectionLabel.textContent = display;
    this.setAttribute('data-selected', value);
  }
}

if (!customElements.get('divano-variant-slideover')) {
  customElements.define('divano-variant-slideover', DivanoVariantSlideover);
}

}
